import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultDownloadInfo } from '../interfaces/Result'
import { useAuth } from './useAuth'

interface C807ConversationDownloadProps {
  execSummaryDownload: (convId: string) => Promise<ResultDownloadInfo>
  loading: loadStatus
}
// C808 会話要約ダウンロードAPI呼出
export const useC808SummaryDownload = (): C807ConversationDownloadProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const execSummaryDownload = async (convId: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const response = await axios.get(
        `${baseUrl}${stage}${apiUrl.conversationsPath}${convId}/download-summary`,
        {
          headers: header,
          // responseType: "blob",
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        // console.log(
        //   `content-disposition: ${response.headers["content-disposition"]}`
        // );
        // レスポンスヘッダからファイル名を取得
        // const contentDisposition = response.headers["content-disposition"];
        // if (contentDisposition) {
        //   const fileName = getFileName(contentDisposition);
        //   fileDownload(response.data, fileName);
        // }
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execSummaryDownload, loading }
}
